import { CrudTable, Rating } from "@/components/shared";

const AREAS = ["Reception", "Waiting Lounge", "Consultation Room", "Operation Theatre", "Restroom", "Exterior", "Overall"];

const overall = (r) => {
  const t = [r.cleanliness, r.ambience, r.staff_grooming].filter((x) => x);
  return t.length ? (t.reduce((a, b) => a + b, 0) / t.length).toFixed(1) : "—";
};

export default function LookFeel() {
  const columns = [
    { key: "date", label: "Date", render: (r) => r.date?.slice(0, 10) },
    { key: "branch", label: "Branch" },
    { key: "area", label: "Area" },
    { key: "cleanliness", label: "Cleanliness", render: (r) => <Rating value={r.cleanliness} /> },
    { key: "ambience", label: "Ambience", render: (r) => <Rating value={r.ambience} /> },
    { key: "staff_grooming", label: "Staff Grooming", render: (r) => <Rating value={r.staff_grooming} /> },
    { key: "overall", label: "Overall", render: (r) => {
      const v = overall(r);
      const num = parseFloat(v);
      const color = num >= 4 ? "text-[#34d399]" : num >= 3 ? "text-[#C9A24B]" : "text-[#f87171]";
      return <span className={`font-mono-ync font-semibold ${color}`}>{v}</span>;
    } },
    { key: "auditor", label: "Auditor" },
  ];
  const fields = [
    { key: "branch", label: "Branch", type: "select", optionsKey: "branches" },
    { key: "area", label: "Area", type: "select", options: AREAS },
    { key: "date", label: "Audit Date", type: "date" },
    { key: "cleanliness", label: "Cleanliness (1-5)", type: "number", min: 1, max: 5, step: 1 },
    { key: "ambience", label: "Ambience (1-5)", type: "number", min: 1, max: 5, step: 1 },
    { key: "staff_grooming", label: "Staff Grooming (1-5)", type: "number", min: 1, max: 5, step: 1 },
    { key: "auditor", label: "Auditor", type: "text" },
    { key: "notes", label: "Notes", type: "textarea", full: true },
  ];
  return (
    <CrudTable
      testid="lookfeel" endpoint="ambience"
      title="Look & Feel of Youngness Centre"
      subtitle="Audit the premises — cleanliness, ambience and staff grooming — so every branch reflects the luxury brand."
      columns={columns} fields={fields}
      defaults={{ area: "Overall" }}
    />
  );
}
